import axios from 'axios';
import * as jsonpatch from 'fast-json-patch';
import { FilterChangelogPatch } from '../shared/field_inputs/HelpMethods';

const CancelToken = axios.CancelToken;
let cancel;

export async function HandleAddPerson(person) {
    const url = 'api/crmPersonFront/addPerson/';

    const res = await axios.post(url, person).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}

export async function HandlePatchPerson(initialPerson, newPerson) {
    const patch = jsonpatch.compare(initialPerson, newPerson);
    let changelogPatch = [];

    patch.forEach((operation) => {
        operation.oldValue = jsonpatch.getValueByPointer(initialPerson, operation.path);
    });

    changelogPatch = FilterChangelogPatch(patch);

    const url = 'api/crmPersonFront/patchPerson/';
    const body = {
        entityId: initialPerson.id,
        serializedPatch: JSON.stringify(patch),
        serializedChangelogPatch: JSON.stringify(changelogPatch),
    };

    const response = await axios.put(url, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, person: response.data };
            } else {
                return { success: false, error: response.data.message, person: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return response;
}

export async function HandleDeletePerson(personId) {
    const url = 'api/crmPersonFront/deletePerson/';
    const query = { personId: personId };

    const response = await axios.delete(url, { params: query }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, deal: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    deal: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                deal: null,
            };
        }
    );
    return response;
}

export async function GetPersonHistory(personId, callback) {
    cancel && cancel();

    const uri = `api/crmPersonFront/getPersonHistory/`;
    const params = { personId };

    try {
        axios
            .get(uri, {
                params,
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }

                return callback({ success: false });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false });
    }
}

export async function GetActivePerson(personId, callback) {
    cancel && cancel();

    const uri = `api/crmPersonFront/getPerson`;
    const params = { personId };

    try {
        axios
            .get(uri, {
                params,
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }

                return callback({ success: false });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false });
    }
}

//export async function HandleDeletePerson(person) {
//    async function DeletePerson() {
//        const url = 'api/crmPerson/deletePerson/';
//        const body = { person };
//
//        let res = await axios.post(url, body).then(
//            (response) => {
//                if (response.data.success) {
//                    return { success: true, error: null, data: response.data };
//                } else {
//                    return { success: false, error: response.data.message, data: null };
//                }
//            },
//            (error) => {
//                return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
//            }
//        );
//
//        return res;
//    }
//
//    return await DeletePerson();
//}
